import { FeatureModule } from '@/features/earn';
import en from '@/features/bill-payment/screens/union-pay/i18n/en.json';
import zhCn from '@/features/bill-payment/screens/union-pay/i18n/zh-CN.json';
import zhHk from '@/features/bill-payment/screens/union-pay/i18n/zh-HK.json';
import jaJp from '@/features/bill-payment/screens/union-pay/i18n/ja-JP.json';
import { BillPaymentStackRoutes } from '@/features/bill-payment/payment.navigator';

const UnionPayApp: FeatureModule = {
  name: BillPaymentStackRoutes.UnionPay,
  version: '1.0.0',
  hooks: {},
  screens: {},
  routes: {},
  i18n: {
    en: en as Record<string, any>,
    'zh-HK': zhHk as Record<string, any>,
    'zh-CN': zhCn as Record<string, any>,
    'ja-JP': jaJp as Record<string, any>
  }
};

export default UnionPayApp;
